import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedoAlt } from "@fortawesome/free-solid-svg-icons";

const RedoCircleIcon = () => {
  return <FontAwesomeIcon icon={faRedoAlt} />;
};

export default RedoCircleIcon;
